// extracted by mini-css-extract-plugin
module.exports = {"root":"_1IXrL","list":"_1_7fE","name":"_3a18Y","separator":"_1W1G8","link":"_1VsJR"};